import React, { Component } from 'react'

import firebase from 'firebase'
import Swiper from 'react-slider-swiper'
import { find } from 'lodash'
import moment from 'moment'

import 'react-slider-swiper/src/styles/css/swiper.css'
import './styles/TimeLineSectionStyles.css'


class TimeLineSection extends Component {
    constructor(props) {
        super(props)

        this.state = {
            popoverObject: null,

            objects: []
        }
    }

    componentDidMount() {

        const objRef = firebase.database().ref('objects')

        objRef.on('value', this.setObjData.bind(this))
    }

    setObjData(snapshot) {
        const data = snapshot.val()

        if (data) {

            const objects = []

            for (let key in data) {
                const item = data[key]
                if (item.isReady && item.isVisible) {
                    objects.push(data[key])
                }
            }

            this.setState({
                objects: objects
            })
        }
    }

    _renderTags(tags) {
        if (!tags) {
            return null
        }
        let tagsArr = []

        for (let key in tags) {
            tagsArr.push(tags[key])
        }
        return tagsArr.map((item, i) => {
            return (
                <Tag key={`Tag${i}`} title={item.title} />
            )
        })
    }

    getPhoto(item) {
        if (item.photo && item.photo.length) {
            const photo = find(item.photo, { isMain: true })
            if (photo) {
                return photo.url
            } else {
                return item.photo[0].thumbUrl ? item.photo[0].thumbUrl : item.photo[0].url
            }
        } else {
            return ''
        }
    }

    _renderSlides() {
        return this.state.objects.map((item, i) => {

            return (
                <div key={`TimeLineSlide${i}`} id={item.id} className={'TimeLineSlide columns is-gapless'} >

                    <div className="TimeLineSectionSlideContentWrapper ">
                        <div className="TimeLineSectionSlideContentWrapperOverlay"> </div>
                        <div style={{ backgroundImage: `url("${this.getPhoto(item)}")` }} className="TimeLineSectionSlideImage "></div>

                    </div>
                    <div className="TimeLineSectionSlideSpacer column is-one-quarter"></div>
                    <div className="TimeLineSectionSlideData column is-half">
                        <div className="TimeLineSectionSlideDateWrapper">
                            <div className="TimeLineSectionSlideDateWrapperInner">
                                <div className="TimeLineContainer">
                                    <div className="TimeLineSectionSlideDateWrapperDot" />
                                    {item.date}
                                </div>
                            </div>
                        </div>
                        <div className="TimeLineSectionSlideTitleWrapper">
                            {item.title}
                        </div>
                        <div className="TimeLineSectionSlidePlaceWrapper">
                            <div className="pinWrapper" />
                            <div className="PinAddressWrapper">
                                {item.address}
                            </div>
                        </div>

                        <div className={"TimeLineSectionSlideDescriptionWrapper"}>
                            {item.descr}
                        </div>
                        <div className="TimeLineSectionSlideTagsWrapper">
                            {this._renderTags(item.tags)}
                        </div>
                    </div>
                </div>
            )
        })
    }

    render() {
        const now = moment().format('x')
        const breakpoints = {
            2024: {
                slidesPerView: 3,
                spaceBetween: 0
            },
            1024: {
                slidesPerView: 2,
                spaceBetween: 0
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 0
            },
            640: {
                slidesPerView: 1,
                spaceBetween: 30
            },
            320: {
                slidesPerView: 1,
                spaceBetween: 30
            }
        }

        return (
            <div className="TimeLineSection">
                <div className="TimeLineSectionSlider">
                    {(this.state.objects.length > 0) ? (
                        <Swiper
                            key={`TomelineSwiper${now}`}
                            pagination={'.noDots'}
                            paginationClickable={true}
                            nextButton={'.SliderNextArrowTimeline'}
                            prevButton={'.SliderPrevArrowTimeline'}
                            spaceBetween={0}
                            slidesPerView={3}
                            loop={true}
                            breakpoints={breakpoints}
                            onClick={(swiper, event) => {
                                if (swiper.clickedSlide) {
                                    const object = find(this.state.objects, { 'id': swiper.clickedSlide.id })
                                    if (object) {
                                        console.log('object', object)
                                        this.props.Popover.show(object)
                                    }
                                }

                            }}
                            onTap={(swiper, event) => {
                                if (swiper.clickedSlide) {
                                    const object = find(this.state.objects, { 'id': swiper.clickedSlide.id })
                                    if (object) {
                                        this.props.Popover.show(object)
                                    }
                                }
                            }}
                        >
                            {this._renderSlides()}
                        </Swiper>
                    ) : null}
                </div>
            </div>
        )
    }
}

const Tag = (props) => {
    return (
        <div className="TimeLineTagWrapper">
            {props.title || 'empty'}
        </div>
    )
}

export default TimeLineSection


// WEBPACK FOOTER //
// ./src/Components/Sections/TimeLineSection.js